var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { Box } from "@mui/material";
import { Button } from "../../../../../Atoms";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Context } from "../../../context";
var iconStyles = {
    minWidth: "unset",
    padding: "0",
};
var absoluteStyles = __assign(__assign({}, iconStyles), { position: "absolute" });
var NavBar = function (_a) {
    var backPage = _a.backPage, closePage = _a.closePage;
    var _b = useContext(Context), setPage = _b.setPage, hasShadow = _b.hasShadow;
    var backFn = function () { return (backPage ? setPage(backPage) : null); };
    var closeFn = function () { return (closePage ? setPage(closePage) : null); };
    var useAbsPosition = !hasShadow;
    return (_jsxs(Box, __assign({ sx: { display: "flex", minHeight: "40px", position: "relative" } }, { children: [backPage && (_jsx(Button, __assign({ "data-testid": "back-button", onClick: backFn, variant: "text", sx: __assign(__assign({}, (useAbsPosition ? absoluteStyles : iconStyles)), { left: useAbsPosition ? "-24px" : "" }) }, { children: _jsx(ArrowBackRoundedIcon, {}) }))), closePage && (_jsx(Button, __assign({ "data-testid": "close-button", onClick: closeFn, sx: __assign(__assign({}, (useAbsPosition ? absoluteStyles : iconStyles)), { right: useAbsPosition ? "-24px" : "", ml: useAbsPosition ? "" : "auto" }), variant: "text" }, { children: _jsx(CloseRoundedIcon, {}) })))] })));
};
export default NavBar;
